import { render, staticRenderFns } from "./PFIDashboard.vue?vue&type=template&id=7aeb5d8b&"
import script from "./PFIDashboard.vue?vue&type=script&lang=js&"
export * from "./PFIDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PFIDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports